rimg.shopify.init('[data-rimg="lazy"]', { round: 1 });

const sections = new ShopifySectionsManager();

sections.register('age-gate', section => new AgeGate.PageAgeGate(section));

const ageGatePage = document.getElementById('age-gate-page');

if (ageGatePage) {
  new AgeGate.SiteAgeGate(ageGatePage);
}

// Document ready
$(() => {

  window.utils.enableDisclosure();
  const oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', () => {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();

  window.objectFitImages();
  window.header.init();
  window.mobileSearch.init();
  window.siteOverlay.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.predictiveSearch.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.logoList.init();
  window.collectionSidebarFilter.init();
  window.cart.init();
  window.map.init();
  window.shoppableImage.init();
  window.productPage.init();
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();

  if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const { pathname } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0,
    }, 'slow');
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', () => {
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = $(window).width();
        // Run our resize functions
        if (window.PXUTheme.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          window.cart.init();
          if (!window.is_touch_device()) {
            window.header.unload();
            window.header.init();
          }
        }

        window.logoList.init();

        // swap lazysizes background mobile images when browser is resized
        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');

          if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }

            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Lightbox default options
  // https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };

  // backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Find youtube and vimeo iframes
  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return (Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9)) ? '4:3' : '16:9';
  }

  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr('src');

    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  // Initiate lazyframe
  window.lazyframe('.lazyframe');

  // Wrap shopify policy in grid layout classes
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Add classes to determine column size
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');

  // Add featured divider beneath page title
  $('.shopify-policy__title').append('<div class="feature-divider"></div>');

  // Collection sorting

  const sortByEl = document.querySelector('[data-sort-by]');

  if (sortByEl) {
    sortByEl.addEventListener('change', e => {
      const { target } = e;
      const sortValue = target.value;
      if (target) {
        // Set the query string and redirect
        const queryString = new URLSearchParams(document.location.search);
        queryString.set('sort_by', sortValue);
        window.location.search = queryString;
      }
    });
  }

  $('body')
    .on('change', '#tag_filter', () => {
      $('[data-option-filter] input').prop('checked', false);
      window.quickFilter.init();
    });

  $('body')
    .on('change', '#blog_filter', function () {
      const url = $(this).val();
      window.location = url;
    });

  $('input, select, textarea').on('focus blur', event => {
    $('meta[name=viewport]').attr('content', `width=device-width,initial-scale=1,maximum-scale=${event.type === 'blur' ? 10 : 1}`);
  });

  // Collection sidebar filter
  // Check the checkbox values
  $('body').on('change', '[data-option-filter] input', () => {
    window.quickFilter.init();
    $('html, body').animate({
      scrollTop: ($('.content').offset().top),
    }, 500);
  });

  $('body').on('click', '[data-reset-filters]', () => {
    window.collectionSidebarFilter.clearAllFilters();
  });

  $('body').on('click', '[data-clear-filter]', e => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents('.filter-active-tag');
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $('body').on('change', '.js-quick-shop select', () => {
    const currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && window.globalQuickShopProduct) {
      window.quickShop.updateVariant(currentVariant);
    }
  });

  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }

  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document).bind('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });

  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });

  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }

  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({ scrollTop: $('#new-comment').offset().top - 140 }, 'slow');
  }

  if (window.PXUTheme.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, { offset: '70%' });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, { offset: '70%' });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, { offset: '70%' });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, { offset: '70%' });
  }

  // backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2,
  });

  window.utils.createAccordion('.footer_menu', 'h6', 'ul');
  window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  window.utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

  window.utils.initializeTabs();
  window.accordion.init();

  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });

  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function () {
        $('.swatch span', $(this)).each(function () {
          if ($(this).data('image').indexOf('no-image') === -1) {
            $('<img/>')[0].src = $(this).data('image');
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data('image'));
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data('image'));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }

  if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
    // Terms of service on mini-cart && cart page
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (window.PXUTheme.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = window.PXUTheme.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning }</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', e => {
      // Redirect to cart page
      e.preventDefault();
      document.location.href = window.PXUTheme.routes.cart_url;
    });
  }

  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.custom-contact__checkbox');
    $checkboxGroup.prop('required', true);

    $checkboxGroup.on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }

  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('.product-list');
  }

  if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll('.product-list');
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  function cartRoute(path) {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return `${root}${path}`;
  }

  function ownProperty(object, key) {
    return Object.prototype.hasOwnProperty.call(object || {}, key);
  }

  function parseContractList(value) {
    if (Array.isArray(value)) return value.map(String);
    if (value === null || value === undefined || value === '') return [];
    const raw = String(value).trim();
    if (raw.charAt(0) === '[') {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed.map(String);
      } catch (_error) {
        // Fall through to the legacy/derived scalar delimiter parser.
      }
    }
    // Live Bold v2.15.20 arrays are comma-delimited. Pipe remains accepted for
    // defensive rollback compatibility.
    return raw.split(/[|,]/).map(valuePart => valuePart.trim().replace(/^['"]|['"]$/g, '')).filter(Boolean);
  }

  function parseContractSlots(value) {
    if (Array.isArray(value)) return value.map(valuePart => String(valuePart).trim());
    if (value === null || value === undefined || value === '') return [];
    const raw = String(value).trim();
    if (raw.charAt(0) === '[') {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed.map(valuePart => String(valuePart).trim());
      } catch (_error) {
        // Fall through to the legacy/derived scalar delimiter parser.
      }
    }
    const delimiter = raw.indexOf('|') !== -1 && raw.indexOf(',') === -1 ? '|' : ',';
    return raw.split(delimiter).map(valuePart => valuePart.trim().replace(/^['"]|['"]$/g, ''));
  }

  function positiveContractInteger(value) {
    const raw = String(value === undefined || value === null ? '' : value).trim();
    if (!/^[1-9]\d*$/.test(raw)) return false;
    const numeric = Number(raw);
    return Number.isSafeInteger(numeric) && numeric > 0;
  }

  function parseVariantQuantities(value, modes, count) {
    if (!modes.length) {
      const legacy = parseContractList(value);
      if (legacy.length && legacy.length !== count) return null;
      if (legacy.some(quantity => !positiveContractInteger(quantity))) return null;
      return legacy;
    }
    if (modes.length !== count) return null;
    let slots = parseContractSlots(value);
    if (!slots.length && (value === null || value === undefined || value === '')) {
      slots = Array(count).fill('');
    }
    if (slots.length !== count) return null;
    const valid = modes.every((mode, index) => {
      if (mode === 'FOLLOW_MAIN') return slots[index] === '';
      if (mode === 'EDITABLE_ABSOLUTE') return positiveContractInteger(slots[index]);
      return false;
    });
    return valid ? slots : null;
  }

  function contractBoolean(value) {
    return ['1', 'true', 'yes'].indexOf(String(value).toLowerCase()) !== -1;
  }

  function supportedBuilderId(value) {
    const raw = String(value === undefined || value === null ? '' : value).trim();
    if (/^\d{15}$/.test(raw)) return true;
    if (!/^[+-]?\d{1,10}$/.test(raw)) return false;
    const numeric = Number(raw);
    return Number.isInteger(numeric) && numeric >= -2147483648 && numeric <= 2147483647;
  }

  function classifyCart(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const roles = new Map();
    const groups = [];
    const mainsByBuilder = new Map();

    items.forEach((item) => {
      roles.set(item.key, { role: 'ungrouped', item });
      const properties = item.properties || {};
      const builderId = properties._boldBuilderId && String(properties._boldBuilderId).trim();
      if (supportedBuilderId(builderId)
          && ownProperty(properties, '_boldVariantIds')
          && parseContractList(properties._boldVariantIds).length) {
        if (!mainsByBuilder.has(builderId)) mainsByBuilder.set(builderId, []);
        mainsByBuilder.get(builderId).push(item);
      }
    });

    mainsByBuilder.forEach((mains, builderId) => {
      // A builder collision or forged duplicate main is never grouped visually.
      if (mains.length !== 1) return;
      const main = mains[0];
      const properties = main.properties || {};
      const variantIds = parseContractList(properties._boldVariantIds);
      const productIds = parseContractList(properties._boldProductIds);
      const prices = parseContractList(properties._boldVariantPrices);
      const modes = parseContractList(properties._wotVariantQuantityModes);
      const quantities = parseVariantQuantities(properties._boldVariantQtys, modes, variantIds.length);
      const choiceHandles = parseContractList(properties._wotChoiceHandles);
      const lineOneTime = parseContractList(properties._boldLineItemOneTime);
      const productOneTime = parseContractList(properties._boldProductOneTime);
      const orderOneTime = parseContractList(properties._boldOrderOneTime);

      if (!variantIds.length
          || productIds.length !== variantIds.length
          || prices.length !== variantIds.length
          || quantities === null) return;

      const candidates = items.filter((item) => {
        const candidateProperties = item.properties || {};
        return String(candidateProperties._boldBuilderId || '') === builderId
          && !ownProperty(candidateProperties, '_boldVariantIds');
      });
      const usedKeys = new Set();
      const entries = [];
      let valid = true;

      variantIds.forEach((variantId, index) => {
        const expectedChoice = choiceHandles[index] || '';
        const matches = candidates.filter((candidate) => {
          if (usedKeys.has(candidate.key) || String(candidate.variant_id || candidate.id) !== String(variantId)) return false;
          if (!expectedChoice) return true;
          return String((candidate.properties || {})._wotChoiceHandle || '') === expectedChoice;
        });
        if (matches.length !== 1) {
          valid = false;
          return;
        }
        const companion = matches[0];
        usedKeys.add(companion.key);
        entries.push({
          companion,
          baseQuantity: quantities.length
            ? Math.max(1, Number.parseInt(quantities[index], 10) || 1)
            : 1,
          mode: modes[index] || 'FOLLOW_MAIN',
          lineOneTime: contractBoolean(lineOneTime[index]),
          productOneTime: contractBoolean(productOneTime[index]),
          orderOneTime: contractBoolean(orderOneTime[index]),
          variantId: String(variantId),
        });
      });

      // Orphan/extra paid lines with the same builder make the whole group
      // untrusted and therefore individually visible.
      if (!valid || entries.length !== variantIds.length || usedKeys.size !== candidates.length) return;
      const group = { builderId, main, entries };
      groups.push(group);
      roles.set(main.key, { role: 'main', item: main, group });
      entries.forEach((entry) => roles.set(entry.companion.key, {
        role: 'companion',
        item: entry.companion,
        group,
        entry,
      }));
    });

    return { cart, groups, roles };
  }

  function logicalItemCount(cart) {
    const contract = classifyCart(cart);
    return (cart.items || []).reduce((total, item) => {
      const role = contract.roles.get(item.key);
      return total + (role && role.role === 'companion' ? 0 : item.quantity);
    }, 0);
  }

  function cartElement(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function safeCartURL(value) {
    try {
      const parsed = new URL(String(value || ''), window.location.origin);
      if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.href;
    } catch (_error) {
      return '';
    }
    return '';
  }

  function appendVisibleProperties(container, properties) {
    Object.keys(properties || {}).forEach((key) => {
      const value = properties[key];
      if (!value || key.charAt(0) === '_') return;
      const row = cartElement('div');
      row.append(document.createTextNode(`${key}: `));
      if (String(value).indexOf('/uploads/') !== -1 && safeCartURL(value)) {
        const link = cartElement('a', null, 'Uploaded File');
        link.href = safeCartURL(value);
        row.append(link);
      } else {
        row.append(document.createTextNode(String(value)));
      }
      container.append(row);
    });
  }

  function appendGroupedAddons(container, group) {
    if (!group || !group.entries.length) return;
    const list = cartElement('ul', 'wot-cart-addons');
    group.entries.forEach(({ companion }) => {
      const item = cartElement('li', 'wot-cart-addons__item');
      const title = companion.product_title || companion.title || 'Configured add-on';
      const total = window.Shopify.formatMoney(companion.final_line_price, $('body').data('money-format'));
      item.textContent = `${title} × ${companion.quantity} — ${total}`;
      list.append(item);
    });
    container.append(list);
  }

  function lineDiscounts(item) {
    const allocations = item.line_level_discount_allocations || item.discount_allocations || [];
    if (allocations.length) {
      return allocations.map((allocation) => ({
        title: allocation.discount_application
          ? allocation.discount_application.title
          : (allocation.title || ''),
        amount: allocation.amount || 0,
      }));
    }
    return item.discounts || [];
  }

  function captureMiniCartMetadata() {
    const metadata = new Map();
    document.querySelectorAll('.js-cart_items [data-cart-item][data-cart-key]').forEach((row) => {
      if (metadata.has(row.dataset.cartKey)) return;
      metadata.set(row.dataset.cartKey, {
        productTitle: row.dataset.productTitle || '',
        variantTitle: row.dataset.variantTitle || '',
        hasOnlyDefaultVariant: row.dataset.productHasOnlyDefaultVariant === 'true',
        compareAtPrice: Number(row.dataset.compareAtPrice || 0),
        quantityMax: Number(row.dataset.quantityMax || 0),
      });
    });
    return metadata;
  }

  function formVariantMetadata(item) {
    let match = null;
    document.querySelectorAll('[data-product-form][data-product]').forEach((wrapper) => {
      if (match || String(wrapper.dataset.productId || '') !== String(item.product_id || '')) return;
      try {
        const product = JSON.parse(wrapper.dataset.product);
        const variant = (product.variants || []).find((candidate) => {
          return String(candidate.id) === String(item.variant_id || item.id);
        });
        if (!variant) return;
        let quantityMax = 0;
        if (wrapper.dataset.variantInventory) {
          const inventory = JSON.parse(wrapper.dataset.variantInventory).find((entry) => {
            return String(entry.id) === String(variant.id);
          });
          if (inventory && inventory.inventory_management
              && inventory.inventory_policy === 'deny'
              && Number(inventory.inventory_quantity) > 0) {
            quantityMax = Number(inventory.inventory_quantity);
          }
        }
        match = {
          productTitle: product.title || '',
          variantTitle: variant.title || '',
          hasOnlyDefaultVariant: (product.variants || []).length === 1 && String(variant.title || '').indexOf('Title') !== -1,
          compareAtPrice: Number(variant.compare_at_price || 0),
          quantityMax,
        };
      } catch (_error) {
        match = null;
      }
    });
    return match || {};
  }

  function miniCartMetadata(item, existing) {
    const formMetadata = formVariantMetadata(item);
    const variant = item.variant || {};
    const variantTitle = item.variant_title || variant.title || formMetadata.variantTitle || (existing && existing.variantTitle) || '';
    return {
      productTitle: item.product_title || (item.product && item.product.title) || formMetadata.productTitle || (existing && existing.productTitle) || item.title || 'Product',
      variantTitle,
      hasOnlyDefaultVariant: typeof item.product_has_only_default_variant === 'boolean'
        ? item.product_has_only_default_variant
        : (formMetadata.hasOnlyDefaultVariant !== undefined
          ? formMetadata.hasOnlyDefaultVariant
          : Boolean(existing && existing.hasOnlyDefaultVariant)),
      compareAtPrice: Number(
        item.compare_at_price
        || variant.compare_at_price
        || formMetadata.compareAtPrice
        || (existing && existing.compareAtPrice)
        || 0
      ),
      quantityMax: Number(
        formMetadata.quantityMax
        || (existing && existing.quantityMax)
        || 0
      ),
    };
  }

  function appendUnitPrice(container, item) {
    const measurement = item.unit_price_measurement;
    if (!measurement || !item.unit_price || Number(item.price || 0) <= 0) return;
    const unit = cartElement('p', 'mini-cart__unit-price');
    const quantityValue = measurement.quantity_value === undefined ? '' : measurement.quantity_value;
    const quantityUnit = measurement.quantity_unit || '';
    unit.append(cartElement('span', 'mini-cart__unit-price-total-quantity', `${quantityValue}${quantityUnit}`));
    unit.append(document.createTextNode(' | '));
    unit.append(cartElement(
      'span',
      'mini-cart__unit-price-amount money',
      window.Shopify.formatMoney(item.unit_price, $('body').data('money-format')),
    ));
    unit.append(document.createTextNode(' / '));
    const referenceValue = Number(measurement.reference_value) === 1 ? '' : (measurement.reference_value || '');
    unit.append(cartElement('span', 'mini-cart__unit-price-measure', `${referenceValue}${measurement.reference_unit || ''}`));
    container.append(unit);
  }

  function createSuppressedCartInput(item) {
    const input = cartElement('input', 'wot-grouped-input cart__product-qty');
    input.type = 'hidden';
    input.name = 'updates[]';
    input.value = String(item.quantity);
    input.dataset.id = item.key;
    return input;
  }

  function createMiniCartItem(item, index, role, existingMetadata) {
    const lineID = index + 1;
    const metadata = miniCartMetadata(item, existingMetadata);
    const row = cartElement('li', 'mini-cart__item');
    row.dataset.cartItem = '';
    row.dataset.cartKey = item.key;
    row.dataset.lineId = String(lineID);
    row.dataset.variantId = String(item.id);
    row.dataset.wotRole = role.role;
    if (role.role === 'main') row.dataset.wotBuilderId = role.group.builderId;
    row.dataset.productTitle = metadata.productTitle;
    row.dataset.variantTitle = metadata.variantTitle;
    row.dataset.productHasOnlyDefaultVariant = metadata.hasOnlyDefaultVariant ? 'true' : 'false';
    row.dataset.compareAtPrice = String(metadata.compareAtPrice || 0);
    if (metadata.quantityMax > 0) row.dataset.quantityMax = String(metadata.quantityMax);

    const itemURL = safeCartURL(item.url) || cartRoute('cart');
    const imageLink = cartElement('a');
    imageLink.href = itemURL;
    if (item.image) {
      const imageWrap = cartElement('div', 'cart_image mini-cart__item-image');
      const image = cartElement('img');
      const imageSource = safeCartURL(String(item.image).replace(/(\.[^.]*)$/, '_compact$1'));
      image.alt = item.title || '';
      if (imageSource) {
        image.src = imageSource;
        imageWrap.append(image);
        imageLink.append(imageWrap);
      }
    }
    row.append(imageLink);

    const content = cartElement('div', 'mini-cart__item-content');
    const titleWrap = cartElement('div', 'mini-cart__item-title');
    let title = metadata.productTitle;
    if (!metadata.hasOnlyDefaultVariant
        && metadata.variantTitle
        && metadata.variantTitle.indexOf('Title') === -1) {
      const options = (item.variant_options || (item.options_with_values || []).map((option) => option.value)).filter(Boolean);
      title += ` - ${(options.length ? options : [metadata.variantTitle]).join(' / ')}`;
    }
    const titleLink = cartElement('a', null, title);
    titleLink.href = itemURL;
    titleWrap.append(titleLink);
    if (item.selling_plan_allocation) {
      titleWrap.append(cartElement('div', 'meta', item.selling_plan_allocation.selling_plan.name));
    }
    const properties = cartElement('div', 'line-item');
    appendVisibleProperties(properties, item.properties);
    if (properties.childNodes.length) titleWrap.append(properties);
    if (role.role === 'main') appendGroupedAddons(titleWrap, role.group);
    content.append(titleWrap);

    const discounts = lineDiscounts(item);
    const isSale = (metadata.compareAtPrice > Number(item.price || 0)) || discounts.length > 0;
    const priceWrap = cartElement('div', 'mini-cart__item-price');
    if (Number(item.price || 0) > 0) {
      priceWrap.append(cartElement(
        'span',
        `money${isSale ? ' sale' : ''}`,
        window.Shopify.formatMoney(item.final_price, $('body').data('money-format')),
      ));
      const wasPrice = metadata.compareAtPrice || (discounts.length ? Number(item.original_price || 0) : 0);
      if (isSale && wasPrice > 0) {
        priceWrap.append(document.createTextNode(' '));
        priceWrap.append(cartElement(
          'span',
          'money was_price',
          window.Shopify.formatMoney(wasPrice, $('body').data('money-format')),
        ));
      }
    } else {
      priceWrap.append(document.createTextNode(window.PXUTheme.translation.cart_free_text));
    }
    content.append(priceWrap);
    appendUnitPrice(content, item);
    discounts.forEach((discount) => {
      content.append(cartElement('p', 'notification-discount meta', discount.title));
    });

    const quantityBox = cartElement('div', 'product-quantity-box');
    const minus = cartElement('span', 'ss-icon product-minus js-change-quantity');
    minus.dataset.func = 'minus';
    minus.append(cartElement('span', 'icon-minus'));
    const quantity = cartElement('input', 'quantity');
    quantity.type = 'number';
    quantity.min = '0';
    quantity.name = 'updates[]';
    quantity.value = String(item.quantity);
    quantity.dataset.id = item.key;
    quantity.dataset.cartQuantityInput = 'mini-cart';
    if (window.PXUTheme.theme_settings.limit_quantity && metadata.quantityMax > 0) {
      quantity.max = String(metadata.quantityMax);
    }
    const plus = cartElement('span', 'ss-icon product-plus js-change-quantity');
    plus.dataset.func = 'plus';
    plus.append(cartElement('span', 'icon-plus'));
    quantityBox.append(minus, quantity, plus);
    content.append(quantityBox);
    row.append(content);

    const remove = cartElement('a', 'js-cart-remove-btn cart__remove-btn');
    remove.href = `${cartRoute('cart/change')}?line=${lineID}&quantity=0`;
    remove.dataset.id = item.key;
    remove.dataset.lineId = String(lineID);
    remove.dataset.removeItem = 'mini-cart';
    remove.append(cartElement('span', 'remove-icon'));
    row.append(remove);
    return row;
  }

  function replaceCartSummary(selector, nodes) {
    document.querySelectorAll(selector).forEach((container) => {
      const fragment = document.createDocumentFragment();
      nodes().forEach(node => fragment.append(node));
      container.replaceChildren(fragment);
    });
  }

  function refreshCart(cart) {
    const contract = classifyCart(cart);
    const existingMetadata = captureMiniCartMetadata();
    const $cartForm = $('[data-cart-form]');
    $cartForm.data('total-discount', cart.total_discount);
    $('.cart_count').text(logicalItemCount(cart));

    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');
    }

    replaceCartSummary('.js-cart_items', () => {
      const rows = [];
      (cart.items || []).forEach((item, index) => {
        const role = contract.roles.get(item.key) || { role: 'ungrouped', item };
        if (role.role === 'companion') {
          // Native cart form submission is positional. Keep one input for every
          // suppressed physical line exactly where that line occurs in cart order.
          rows.push(createSuppressedCartInput(item));
        } else {
          rows.push(createMiniCartItem(item, index, role, existingMetadata.get(item.key)));
        }
      });
      return rows;
    });

    replaceCartSummary('.js-cart_discounts', () => {
      const nodes = [];
      (cart.cart_level_discount_applications || []).forEach((discount) => {
        nodes.push(cartElement('span', 'cart_discounts--title', discount.title));
        nodes.push(cartElement('span', 'cart_discounts--price', `-${window.Shopify.formatMoney(discount.total_allocated_amount, $('body').data('money-format'))}`));
      });
      return nodes;
    });

    replaceCartSummary('.js-cart_subtotal', () => {
      const right = cartElement('span', 'right');
      right.append(cartElement('span', 'money', window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))));
      return [right, cartElement('span', null, window.PXUTheme.translation.cart_subtotal_text)];
    });

    const totalSaving = (cart.items || []).reduce((sum, item) => {
      const metadata = miniCartMetadata(item, existingMetadata.get(item.key));
      return sum + Math.max(0, metadata.compareAtPrice - Number(item.price || 0)) * Number(item.quantity || 0);
    }, 0) + (cart.total_discount || 0);
    replaceCartSummary('.js-cart_savings', () => {
      if (!window.PXUTheme.theme_settings.display_savings || totalSaving <= 0) return [];
      const right = cartElement('span', 'right');
      right.append(cartElement('span', 'money', window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))));
      return [right, cartElement('span', null, window.PXUTheme.translation.cart_savings_text)];
    });

    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }
  }

  async function cartJSON(url, options) {
    const response = await window.fetch(url, options);
    let payload = null;
    try {
      payload = await response.json();
    } catch (_error) {
      payload = null;
    }
    if (!response.ok) {
      throw new Error(payload && (payload.description || payload.message)
        ? payload.description || payload.message
        : `Cart request failed (${response.status}).`);
    }
    return payload;
  }

  function groupUpdates(contract, targetKey, desiredQuantity) {
    const updates = {};
    const mainQuantities = new Map();
    contract.groups.forEach((group) => {
      mainQuantities.set(group.main.key, group.main.key === targetKey ? desiredQuantity : group.main.quantity);
    });
    const orderOnceClaims = new Set();

    contract.groups.forEach((group) => {
      const mainQuantity = mainQuantities.get(group.main.key);
      updates[group.main.key] = mainQuantity;
      group.entries.forEach((entry) => {
        let companionQuantity = 0;
        if (mainQuantity > 0) {
          if (entry.orderOneTime) {
            companionQuantity = orderOnceClaims.has(entry.variantId) ? 0 : 1;
            orderOnceClaims.add(entry.variantId);
          } else if (entry.lineOneTime || entry.productOneTime) {
            companionQuantity = 1;
          } else if (entry.mode === 'EDITABLE_ABSOLUTE') {
            companionQuantity = entry.baseQuantity;
          } else {
            // FIXTURE-CONFIRM-05: absent legacy mode metadata is interpreted as
            // follow-main with _boldVariantQtys as its multiplier.
            companionQuantity = mainQuantity * entry.baseQuantity;
          }
        }
        updates[entry.companion.key] = companionQuantity;
      });
    });
    return updates;
  }

  function extendWarrantyReference(item) {
    const properties = item && item.properties ? item.properties : {};
    const value = properties._Extend && properties._Extend.ProductId
      ? properties._Extend.ProductId
      : (properties['_Extend.ProductId'] || properties.Ref || properties.ref);
    return value === undefined || value === null ? '' : String(value);
  }

  function extendWarrantyPlanId(item) {
    const properties = item && item.properties ? item.properties : {};
    const nested = properties._Extend && properties._Extend.PlanId;
    const explicit = nested || properties['_Extend.PlanId'] || properties.PlanId || properties.planId;
    const sku = item && item.sku ? String(item.sku) : '';
    const reference = extendWarrantyReference(item);
    const skuSuffix = reference ? `-${reference}` : '';
    const legacySkuPlan = skuSuffix && sku.endsWith(skuSuffix)
      ? sku.slice(0, -skuSuffix.length)
      : sku;
    const value = explicit || legacySkuPlan || (item && (item.variant_id || item.id));
    return value === undefined || value === null ? '' : String(value);
  }

  function isExtendWarrantyLine(item) {
    const title = String((item && (item.product_title || item.title)) || '').toLowerCase();
    return Boolean(item && (
      String(item.vendor || '').toLowerCase() === 'extend'
      || extendWarrantyReference(item)
      || title.indexOf('extend protection') !== -1
    ));
  }

  function includeExtendWarrantyUpdates(cart, updates, coveredKeys) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const itemByKey = new Map(items.map((item) => [item.key, item]));
    const references = new Set();
    coveredKeys.forEach((key) => {
      const item = itemByKey.get(key);
      if (item && !isExtendWarrantyLine(item)) {
        references.add(String(item.variant_id || item.id || ''));
      }
    });

    const warrantiesByIdentity = new Map();
    items.filter(isExtendWarrantyLine).forEach((item) => {
      const productId = extendWarrantyReference(item);
      const planId = extendWarrantyPlanId(item);
      if (!productId || !planId || !references.has(productId)) return;
      const identity = `${planId}\u0000${productId}`;
      if (!warrantiesByIdentity.has(identity)) {
        warrantiesByIdentity.set(identity, { planId, productId, lines: [] });
      }
      warrantiesByIdentity.get(identity).lines.push(item);
    });

    warrantiesByIdentity.forEach((identity) => {
      const coveredQuantity = items.reduce((total, item) => {
        if (isExtendWarrantyLine(item)
            || String(item.variant_id || item.id || '') !== identity.productId) return total;
        const quantity = ownProperty(updates, item.key) ? updates[item.key] : item.quantity;
        return total + Math.max(0, Number.parseInt(quantity, 10) || 0);
      }, 0);

      // planId + productId is Extend's offer identity. Distinct plans covering
      // the same product each mirror its total quantity. If a single identity
      // is split across physical Shopify keys, preserve its current allocation
      // and put any remainder on the last key so every key is in this mutation.
      let remaining = coveredQuantity;
      identity.lines.forEach((line, index) => {
        const last = index === identity.lines.length - 1;
        const currentQuantity = Math.max(0, Number.parseInt(line.quantity, 10) || 0);
        const nextQuantity = last ? remaining : Math.min(currentQuantity, remaining);
        updates[line.key] = nextQuantity;
        remaining -= nextQuantity;
      });
    });
    return updates;
  }

  function lockCartUI(locked) {
    document.querySelectorAll('[data-cart-form] input, [data-cart-form] button, [data-cart-form] .js-change-quantity, [data-cart-form] [data-remove-item]').forEach((control) => {
      control.classList.toggle('is-disabled', locked);
      if ('disabled' in control) {
        if (locked) {
          control.dataset.wotWasDisabled = control.disabled ? 'true' : 'false';
          control.disabled = true;
        } else {
          control.disabled = control.dataset.wotWasDisabled === 'true';
          delete control.dataset.wotWasDisabled;
        }
      }
    });
  }

  function cartWarning(message) {
    $('.warning--quantity').remove();
    const warning = cartElement('p', 'warning warning--quantity animated bounceIn', message);
    const form = document.querySelector('[data-cart-form]');
    if (form) form.parentNode.insertBefore(warning, form);
  }

  async function updateCartItemQuantity(cartItem) {
    const desiredQuantity = Math.max(0, Number.parseInt(cartItem.quantity, 10) || 0);
    lockCartUI(true);
    try {
      const current = await cartJSON(cartRoute('cart.js'), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      });
      const contract = classifyCart(current);
      const role = contract.roles.get(cartItem.key);
      let updates = { [cartItem.key]: desiredQuantity };
      let coveredKeys = [cartItem.key];
      if (role && role.role === 'main') {
        updates = groupUpdates(contract, cartItem.key, desiredQuantity);
        coveredKeys = contract.groups.map((group) => group.main.key);
      }
      updates = includeExtendWarrantyUpdates(current, updates, coveredKeys);

      const updated = await cartJSON(cartRoute('cart/update.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ updates }),
      });
      refreshCart(updated);
      window.dispatchEvent(new CustomEvent('refreshAjaxCart', { detail: { cart: updated } }));
      if (cartItem.parentCartForm.data('cart-form') === 'cart-template') window.location.reload();
    } catch (error) {
      let reconciled = null;
      try {
        reconciled = await cartJSON(cartRoute('cart.js'), { credentials: 'same-origin' });
        refreshCart(reconciled);
      } catch (_reconcileError) {
        // The actionable request error below remains the source of truth.
      }
      if (reconciled) {
        const actual = (reconciled.items || []).find(item => item.key === cartItem.key);
        document.querySelectorAll('[data-cart-quantity-input]').forEach((input) => {
          if (input.dataset.id === cartItem.key) input.value = actual ? actual.quantity : 0;
        });
      }
      cartItem.$element.removeClass('fadeOutLeft').addClass('fadeIn');
      cartWarning(`${error.message} The cart was refreshed; check quantities before trying again.`);
    } finally {
      lockCartUI(false);
    }
  }

  window.WOTCart = Object.assign(window.WOTCart || {}, {
    classify: classifyCart,
    logicalItemCount,
    refresh: refreshCart,
  });

  document.addEventListener('wot:cart:updated', (event) => {
    if (event.detail && event.detail.cart) refreshCart(event.detail.cart);
  });

  document.addEventListener('wot:cart:added', () => {
    if ($('#header').is(':visible')) {
      $('#header .cart-container').addClass('active_link');
    } else if ($('.sticky_nav--stick').length) {
      $('.sticky_nav .cart-container').addClass('active_link');
    } else {
      $('.top-bar .cart-container').addClass('active_link');
    }
    if (window.PXUTheme.media_queries.medium.matches) $('body').addClass('blocked-scroll');
  });

  $('body').on('change', '[data-cart-quantity-input]', function () {
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
      key: $(this).data('id'),
    };
    // Disable button after click to prevent multiple clicks
    $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
    updateCartItemQuantity(cartItem);
  });

  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
      key: $(this).data('id'),
    };
    cartItem.$element.addClass('animated fadeOutLeft');

    updateCartItemQuantity(cartItem);
  });

  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    $(document).on('submit', 'form[action*="/cart/add"]', function (e) {
      const form = this;
      const $addToCartForm = $(form);
      const $addToCartBtn = $addToCartForm.find('.add_to_cart.ajax-submit').first();
      if (!$addToCartBtn.length) return true;

      // Configured products must never fall through to the single-line theme
      // request if their form-scoped coordinator failed to initialize.
      if (form.dataset.wotCoordinator === 'true' || form.querySelector('[data-wot-options]')) {
        e.preventDefault();
        return false;
      }

      e.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return false;
      }

      $.ajax({
        url: cartRoute('cart/add.js'),
        dataType: 'json',
        cache: false,
        type: 'post',
        data: window.FormData ? new FormData(form) : $addToCartForm.serialize(),
        contentType: false,
        processData: false,
        beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success() {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          $.ajax({
            url: cartRoute('cart.js'),
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('body').hasClass('cart')) {
                  window.location.reload();
                  return;
                }

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }

                  // Scroll to the top of the page unless the header is fixed
                  const header = document.getElementById('header');
                  if (header.classList.contains('mobile_nav-fixed--false')) {
                    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                  }
                }
              }, 500);
            },
          });
        },
        error(XMLHttpRequest) {
          let response = {};
          try {
            response = JSON.parse(XMLHttpRequest.responseText || '{}');
          } catch (_error) {
            response = {};
          }
          const description = String(response.description || response.message || 'The item could not be added. Please try again.');
          $('.warning').remove();

          const warning = cartElement('p', 'warning animated bounceIn', description.replace('All 1 ', 'All '));
          form.parentNode.insertBefore(warning, form.nextSibling);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('.text').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        },
      });

      return false;
    });
  }

  window.productPage.productSwatches();
});

/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }

  const availableOptions = Shopify.optionsMap[key];
  $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled')
        .removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked')
        .attr('disabled', 'disabled');
    }
  });
};

window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

/* option_selection.js */
function floatToString(t, e) { const o = t.toFixed(e).toString(); return o.match(/^\.\d+/) ? `0${o}` : o; } if (typeof window.Shopify === 'undefined') window.Shopify = {}; window.Shopify.each = function (t, e) { for (let o = 0; o < t.length; o++)e(t[o], o); }, window.Shopify.map = function (t, e) { for (var o = [], i = 0; i < t.length; i++)o.push(e(t[i], i)); return o; }, window.Shopify.arrayIncludes = function (t, e) { for (let o = 0; o < t.length; o++) if (t[o] == e) return !0; return !1; }, window.Shopify.uniq = function (t) { for (var e = [], o = 0; o < t.length; o++)window.Shopify.arrayIncludes(e, t[o]) || e.push(t[o]); return e; }, window.Shopify.isDefined = function (t) { return typeof t === 'undefined' ? !1 : !0; }, window.Shopify.getClass = function (t) { return Object.prototype.toString.call(t).slice(8, -1); }, window.Shopify.extend = function (t, e) { function o() {}o.prototype = e.prototype, t.prototype = new o(), t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype; }, window.Shopify.locationSearch = function () { return window.location.search; }, window.Shopify.locationHash = function () { return window.location.hash; }, window.Shopify.replaceState = function (t) { window.history.replaceState({}, document.title, t); }, window.Shopify.urlParam = function (t) { const e = RegExp(`[?&]${t}=([^&#]*)`).exec(window.Shopify.locationSearch()); return e && decodeURIComponent(e[1].replace(/\+/g, ' ')); }, window.Shopify.newState = function (t, e) { let o; return o = window.Shopify.urlParam(t) ? window.Shopify.locationSearch().replace(RegExp(`(${t}=)[^&#]+`), `$1${e}`) : window.Shopify.locationSearch() === '' ? `?${t}=${e}` : `${window.Shopify.locationSearch()}&${t}=${e}`, o + window.Shopify.locationHash(); }, window.Shopify.setParam = function (t, e) { window.Shopify.replaceState(window.Shopify.newState(t, e)); }, window.Shopify.Product = function (t) { window.Shopify.isDefined(t) && this.update(t); }, window.Shopify.Product.prototype.update = function (t) { for (property in t) this[property] = t[property]; }, window.Shopify.Product.prototype.optionNames = function () { return window.Shopify.getClass(this.options) == 'Array' ? this.options : []; }, window.Shopify.Product.prototype.optionValues = function (t) { if (!window.Shopify.isDefined(this.variants)) return null; const e = window.Shopify.map(this.variants, e => { const o = `option${t + 1}`; return void 0 == e[o] ? null : e[o]; }); return e[0] == null ? null : window.Shopify.uniq(e); }, window.Shopify.Product.prototype.getVariant = function (t) { let e = null; return t.length != this.options.length ? e : (window.Shopify.each(this.variants, o => { for (var i = !0, r = 0; r < t.length; r++) { const n = `option${r + 1}`; o[n] != t[r] && (i = !1); } return i == 1 ? void (e = o) : void 0; }), e); }, window.Shopify.Product.prototype.getVariantById = function (t) { for (let e = 0; e < this.variants.length; e++) { const o = this.variants[e]; if (t == o.id) return o; } return null; }, window.Shopify.money_format = '$', window.Shopify.formatMoney = function (t, e) { function o(t, e) { return typeof t === 'undefined' ? e : t; } function i(t, e, i, r) { if (e = o(e, 2), i = o(i, ','), r = o(r, '.'), isNaN(t) || t == null) return 0; t = (t / 100).toFixed(e); const n = t.split('.'); const a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`); const s = n[1] ? r + n[1] : ''; return a + s; } typeof t === 'string' && (t = t.replace('.', '')); let r = ''; const n = /\{\{\s*(\w+)\s*\}\}/; const a = e || this.money_format; switch (a.match(n)[1]) { case 'amount': r = i(t, 2); break; case 'amount_no_decimals': r = i(t, 0); break; case 'amount_with_comma_separator': r = i(t, 2, '.', ','); break; case 'amount_with_apostrophe_separator': r = i(t, 2, "'", '.'); break; case 'amount_no_decimals_with_comma_separator': r = i(t, 0, '.', ','); } return a.replace(n, r); }, window.Shopify.OptionSelectors = function (t, e) { return this.selectorDivClass = 'selector-wrapper', this.selectorClass = 'single-option-selector', this.variantIdFieldIdSuffix = '-variant-id', this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new window.Shopify.Product(e.product), this.onVariantSelected = window.Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () {}, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new window.Shopify.OptionSelectors.HistoryState(this)), !0; }, window.Shopify.OptionSelectors.prototype.initDropdown = function () { const t = { initialLoad: !0 }; const e = this.selectVariantFromDropdown(t); if (!e) { const o = this; setTimeout(() => { o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t); }); } }, window.Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) { this.selectors[0].element.onchange(t); }, window.Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) { const e = this.selectVariantFromParams(t); e || this.selectVariantFromDropdown(t); }, window.Shopify.OptionSelectors.prototype.replaceSelector = function (t) { const e = document.getElementById(t); const o = e.parentNode; window.Shopify.each(this.buildSelectors(), t => { o.insertBefore(t, e); }), e.style.display = 'none', this.variantIdField = e; }, window.Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) { let e = document.getElementById(this.domIdPrefix).querySelector('[selected]'); if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1; const o = e.value; return this.selectVariant(o, t); }, window.Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) { const e = window.Shopify.urlParam('variant'); return this.selectVariant(e, t); }, window.Shopify.OptionSelectors.prototype.selectVariant = function (t, e) { const o = this.product.getVariantById(t); if (o == null) return !1; for (let i = 0; i < this.selectors.length; i++) { const r = this.selectors[i].element; const n = r.getAttribute('data-option'); const a = o[n]; a != null && this.optionExistInSelect(r, a) && (r.value = a); } return typeof jQuery !== 'undefined' ? jQuery(this.selectors[0].element).trigger('change', e) : this.selectors[0].element.onchange(e), !0; }, window.Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) { for (let o = 0; o < t.options.length; o++) if (t.options[o].value == e) return !0; }, window.Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) { window.Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = `product-${this.product.id}-variant-selector`; const o = document.getElementById(t); window.Shopify.each(this.buildSelectors(), t => { o.appendChild(t); }); }, window.Shopify.OptionSelectors.prototype.buildSelectors = function () { for (let t = 0; t < this.product.optionNames().length; t++) { const e = new window.Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t)); e.element.disabled = !1, this.selectors.push(e); } const o = this.selectorDivClass; const i = this.product.optionNames(); const r = window.Shopify.map(this.selectors, t => { const e = document.createElement('div'); if (e.setAttribute('class', o), i.length > 1) { const r = document.createElement('label'); r.htmlFor = t.element.id, r.innerHTML = t.name, e.appendChild(r); } return e.appendChild(t.element), e; }); return r; }, window.Shopify.OptionSelectors.prototype.selectedValues = function () { for (var t = [], e = 0; e < this.selectors.length; e++) { const o = this.selectors[e].element.value; t.push(o); } return t; }, window.Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) { const o = this.selectedValues(); const i = this.product.getVariant(o); i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, e), this.historyState != null && this.historyState.onVariantChange(i, this, e); }, window.Shopify.OptionSelectorsFromDOM = function (t, e) { const o = e.optionNames || []; const i = e.priceFieldExists || !0; const r = e.delimiter || '/'; const n = this.createProductFromSelector(t, o, i, r); e.product = n, window.Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e); }, window.Shopify.extend(window.Shopify.OptionSelectorsFromDOM, window.Shopify.OptionSelectors), window.Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, e, o, i) {
  if (!window.Shopify.isDefined(o)) var o = !0; if (!window.Shopify.isDefined(i)) var i = '/'; const r = document.getElementById(t); const n = r.childNodes; let a = (r.parentNode, e.length); const s = []; window.Shopify.each(n, (t, r) => {
    if (t.nodeType == 1 && t.tagName.toLowerCase() == 'option') {
      const n = t.innerHTML.split(new RegExp(`\\s*\\${i}\\s*`)); e.length == 0 && (a = n.length - (o ? 1 : 0)); const p = n.slice(0, a); const l = o ? n[a] : ''; const c = (t.getAttribute('value'), {
        available: t.disabled ? !1 : !0, id: parseFloat(t.value), price: l, option1: p[0], option2: p[1], option3: p[2],
      }); s.push(c);
    }
  }); const p = { variants: s }; if (e.length == 0) { p.options = []; for (let l = 0; a > l; l++)p.options[l] = `option ${l + 1}`; } else p.options = e; return p;
}, window.Shopify.SingleOptionSelector = function (t, e, o, i) { this.multiSelector = t, this.values = i, this.index = e, this.name = o, this.element = document.createElement('select'); for (let r = 0; r < i.length; r++) { const n = document.createElement('option'); n.value = i[r], n.innerHTML = i[r], this.element.appendChild(n); } return this.element.setAttribute('class', this.multiSelector.selectorClass), this.element.setAttribute('data-option', `option${e + 1}`), this.element.id = `${t.domIdPrefix}-option-${e}`, this.element.onchange = function (o, i) { i = i || {}, t.updateSelectors(e, i); }, !0; }, window.Shopify.Image = {
  preload(t, e) { for (let o = 0; o < t.length; o++) { const i = t[o]; this.loadImage(this.getSizedImageUrl(i, e)); } }, loadImage(t) { (new Image()).src = t; }, switchImage(t, e, o) { if (t && e) { const i = this.imageSize(e.src); const r = this.getSizedImageUrl(t.src, i); o ? o(r, t, e) : e.src = r; } }, imageSize(t) { const e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./); return e != null ? e[1] : null; }, getSizedImageUrl(t, e) { if (e == null) return t; if (e == 'master') return this.removeProtocol(t); const o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i); if (o != null) { const i = t.split(o[0]); const r = o[0]; return this.removeProtocol(`${i[0]}_${e}${r}`); } return null; }, removeProtocol(t) { return t.replace(/http(s)?:/, ''); },
}, window.Shopify.OptionSelectors.HistoryState = function (t) { this.browserSupports() && this.register(t); }, window.Shopify.OptionSelectors.HistoryState.prototype.register = function (t) { window.addEventListener('popstate', e => { t.selectVariantFromParamsOrDropdown({ popStateCall: !0 }); }); }, window.Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) { this.browserSupports() && (!t || o.initialLoad || o.popStateCall || window.Shopify.setParam('variant', t.id)); }, window.Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () { return window.history && window.history.replaceState; };

$(document)
  .on('shopify:block:select', e => {
    const { blockId } = e.detail;
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials') || $parentSection.hasClass('shopify-section--shoppable-image--slider-enabled')) {
      sliderBlock.select(blockId, $parentSection);
    }
  });

$(document)
  .on('shopify:block:deselect', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials')) {
      window.sliderBlock.deselect($parentSection);
    }
  });

$(document)
  .on('shopify:section:reorder', e => {
    window.utils.initializeSectionWrapper();
  });

$(document)
  .on('shopify:section:load', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    window.utils.initializeSectionWrapper();
    window.utils.enableDisclosure();

    if (window.PXUTheme.theme_settings.enable_autocomplete) {
      window.predictiveSearch.init();
    }

    if (window.PXUTheme.theme_settings.newsletter_popup) {
      window.newsletter_popup.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--blog-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--product-sidebar')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--page-gallery-template')) {
      window.gallery.init($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--gallery')) {
      window.gallery.init();
    }

    if ($parentSection.hasClass('shopify-section--page-faq-template') || $parentSection.hasClass('shopify-section--faq')) {
      window.accordion.init();
    }

    if ($parentSection.hasClass('shopify-section--cart-template')) {
      window.cart.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-promotions')) {
      window.featuredPromotions.init();
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.init();
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
      window.productPage.productSwatches();
    }

    if ($parentSection.hasClass('shopify-section--map')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.init();
    }

    if ($parentSection.hasClass('shopify-section--shoppable-image')) {
      window.shoppableImage.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.init();
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
    }

    if ($parentSection.hasClass('shopify-section--video')) {
      window.video.init();
    }

    if ($parentSection.hasClass('shopify-section--product-template') || $parentSection.hasClass('shopify-section--quick-shop')) {
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
      window.productPage.productSwatches();
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--recommended-products')) {
      window.productPage.init();
    }

    if ($parentSection.hasClass('shopify-section--recently-viewed-products')) {
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      if (window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({ scrollTop: $('#new-comment').offset().top - 140 }, 'slow');
      }
    }

    if ($parentSection.hasClass('shopify-section--collection-template')) {
      window.collectionSidebarFilter.init();
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.sidebarAccordions.init();
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--contact-section')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--search-template')) {
      if (window.PXUTheme.theme_settings.enable_autocomplete) {
        window.predictiveSearch.init();
      }
      window.collectionSidebarFilter.init();
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--header')) {
      window.meganavManager.injectAll();
      window.header.init();
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.add($parentSection[0]);
    }
  });

$(document)
  .on('shopify:section:unload', e => {
    const $target = $(e.target);
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--header')) {
      window.header.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.unload($parentSection.find('[data-logo-wrapper]'));
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--shoppable-image')) {
      window.shoppableImage.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--search')) {
      window.predictiveSearch.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--product-template')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.remove($parentSection[0]);
    }

    // When sections are removed from the DOM, reinitialize the section wrapper
    window.requestAnimationFrame(() => {
      window.utils.initializeSectionWrapper();
    });
  });

$(document)
  .on('shopify:section:select', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.select($parentSection[0]);
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.unload($parentSection);
      window.featuredCollection.init();
    }

    const evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  });

$(document)
  .on('shopify:section:deselect', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.deselect();
    }
  });
